import './Notify.scss';


/**
 * Usage, all params are optional:
 * ui.success('text'?, timeout?)
 * ui.error('text'?, timeout?)
 * ui.warn('text'?, timeout?)
 *
 * @author NikolaV
 */

// shortcut functions
function success(text?: string, timeout?: number, onClick?: () => void, includeHtml?: boolean): NotifyComponent {
    if (typeof text !== 'string') {
        text = kuura.getMessage('js_popup.default_success');
    }
    if (!$.isNumeric(timeout) || timeout < 500 || timeout > 30000) {
        timeout = NotifyComponent.options.timeout;
    }
    return new NotifyComponent('success', text, timeout, onClick, includeHtml).show();
}

function error(text?: string, timeout?: number, onClick?: () => void, includeHtml?: boolean): NotifyComponent {
    if (typeof text !== 'string') {
        text = kuura.getMessage('js_popup.default_error');
    }
    if (!$.isNumeric(timeout) || timeout < 500 || timeout > 30000) {
        timeout = NotifyComponent.options.timeout * 2;
    }
    return new NotifyComponent('error', text, timeout, onClick, includeHtml).show();
}

function warn(text?: string, timeout?: number, onClick?: () => void, includeHtml?: boolean): NotifyComponent {
    if (typeof text !== 'string') {
        text = kuura.getMessage('js_popup.default_warn');
    }
    if (!$.isNumeric(timeout) || timeout < 500 || timeout > 600000) {
        timeout = NotifyComponent.options.timeout;
    }
    return new NotifyComponent('warn', text, timeout, onClick, includeHtml).show();
}

type NotifyType = 'success' | 'error' | 'warn';

class NotifyComponent {
    static options = {
        container: null,
        timeout: 5000,
        showProgress: false,
    };
    private readonly $el: JQuery;
    private readonly $progressEl: JQuery;
    private readonly progressStep: number = 1;
    private progressPercent: number = 0;
    private autoTimeout = null;

    constructor(
        type: NotifyType = 'success',
        text,
        private readonly timeout = NotifyComponent.options.timeout,
        private readonly onClick: (() => void) | null = null,
        private readonly includeHtml: boolean = false
    ) {
        this.$el = $('<div>', {
            class: `info-popup info-popup-${type} anim-in`,
            [this.includeHtml ? 'html' : 'text']: text,
        });
        if (NotifyComponent.options.showProgress) {
            this.$progressEl = $('<div class="info-popup-progress"></div>').appendTo(this.$el);
        }
        this.progressStep = 100 / (timeout / 1000);
    }

    show() {
        // create container and append
        if (!NotifyComponent.options.container) {
            NotifyComponent.options.container = $('<div>', { id: 'info_popups_wrapper' }).appendTo('body');
        }
        NotifyComponent.options.container.prepend(this.$el);

        // fade in
        setTimeout(() => {
            this.$el.removeClass('anim-in');
        }, 40);

        // close on click
        this.$el.on('click', () => {
            if (typeof this.onClick === 'function') {
                this.onClick();
            }
            this.destroy();
        });

        this.$el.on('contextmenu', e => {
            e.preventDefault();
            const wrapper = $('#info_popups_wrapper');
            wrapper.children().each((index, element) => {
                $(element).trigger('click');
            });
        });

        // pause on hover
        this.$el.on('mouseenter', () => {
            if (this.autoTimeout) clearInterval(this.autoTimeout);
            return false;
        });

        this.$el.on('mouseleave', () => {
            this.tick();
            return false;
        });

        // auto close
        if (this.timeout > 100) {
            this.tick();
        }

        return this;
    }

    private tick() {
        this.autoTimeout = setTimeout(() => {
            this.progressPercent += this.progressStep;
            if (NotifyComponent.options.showProgress) {
                this.$progressEl.animate({ width: this.progressPercent + '%' }, 200);
            } else {
                this.$el.animate({ opacity: 1 - this.progressPercent / 250 }, 200);
            }
            if (this.progressPercent >= 100) {
                this.destroy();
            } else {
                this.tick();
            }
        }, 1000);
    }

    private destroy() {
        clearTimeout(this.autoTimeout);

        this.$el.addClass('anim-out');

        setTimeout(() => {
            this.$el.remove();
        }, 300);
    }
}

export const Notify = {
    success,
    error,
    warn,
};
